export var compKey = 'page-container';
//# sourceMappingURL=key.js.map